module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid page-head-wrap"
  }, [_c('div', {
    staticClass: "container page-head text-center"
  }, [_c('p', {
    staticClass: " questionnaire-subhead mb-0 d-inline-block"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui[7][101]"
    }
  })], 1), _vm._v(" "), (_vm.apiLoading) ? _c('p', {
    staticClass: "mb-0"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw",
    staticStyle: {
      "font-size": "14px"
    }
  }), _vm._v(" "), _c('trans-text', {
    attrs: {
      "i18nKey": "ui['5_4_1'][101]"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('page-content', {
    attrs: {
      "cart": _vm.cart,
      "cartPhotos": _vm.cartPhotos,
      "isShowCartPhotoSizePopoverForm": _vm.isShowCartPhotoSizePopoverForm,
      "totalCount": _vm.totalCount,
      "totalPrice": _vm.totalPrice,
      "eventPrices": _vm.eventPrices
    },
    on: {
      "toggleIsShowCartPhotoSizePopoverForm": _vm.toggleIsShowCartPhotoSizePopoverForm,
      "refleshTotal": _vm.refleshTotal,
      "refleshEventPrice": _vm.refleshEventPrice,
      "hideIsShowCartPhotoSizePopoverForm": _vm.hideIsShowCartPhotoSizePopoverForm
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-18470f29!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/subPages/Order/Cart.vue
// module id = 673
// module chunks = 0